import React, { useMemo } from "react"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import { generateRoutes } from "./routes"
import { EExpertProvider } from "./context/EExpertContext"
import { useAuth } from "./context/AuthContext"
import "./styles/app.css"
import "./styles/forms.css"

// Wrapper component for protected routes that need additional providers
const ProtectedWrapper = ({ children }) => {
  const { loading } = useAuth()

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="min-vh-100 d-flex justify-content-center align-items-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Φόρτωση...</span>
        </div>
      </div>
    )
  }

  return <EExpertProvider>{children}</EExpertProvider>
}

// Inner component that uses auth context and generates routes
const AppRoutes = () => {
  const { isExpert, isAdmin } = useAuth()

  const isExpertValue = isExpert()
  const isAdminValue = isAdmin()

  // Regenerate routes whenever user state changes (login/logout)
  const routes = useMemo(() => {
    return generateRoutes(isExpertValue, isAdminValue)
  }, [isExpertValue, isAdminValue])

  const publicRoutes = routes.filter(route => !route.protected)
  const protectedRoutes = routes.filter(route => route.protected)

  return (
    <Routes>
      {/* Public routes outside of other providers */}
      {publicRoutes.map((route, index) => (
        <Route key={`public-${index}`} path={route.path} element={route.element} />
      ))}

      {/* Protected routes wrapped in required providers */}
      {protectedRoutes.map((route, index) => (
        <Route
          key={`protected-${index}`}
          path={route.path}
          element={<ProtectedWrapper>{route.element}</ProtectedWrapper>}
        />
      ))}
    </Routes>
  )
}

const App = () => {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  )
}

export default App
